var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ToolbarItemContainer', {
    attrs: {
      "iconFile": _vm.getIcon(),
      "title": _vm.props.title,
      "iconWidth": _vm.isPC ? '20px' : '25px',
      "iconHeight": _vm.isPC ? '20px' : '25px',
      "needDialog": false,
      "isH5ToolShow": _vm.isH5ToolShow
    },
    on: {
      "onIconClick": _vm.onIconClick
    }
  }, [_c('div', {
    class: ['image-upload', !_vm.isPC && 'image-upload-h5', 'image-video']
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }